import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { useGamesNavigation } from "@state/hooks/games/useGamesNavigation";

export function HeaderGamesNavItem() {
	return <HeaderGamesNavLi />;
}

const HeaderGamesNavLi = observer(function HeaderGamesNavLi() {
	const { t } = useTranslation();
	const { handleGamesRedirection } = useGamesNavigation();

	return (
		<li className="nav--primary__item">
			<div className="nav--primary__link" onClick={handleGamesRedirection}>
				{t("specific:HEADER.CASINO")}
			</div>
		</li>
	);
});
